// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"0e25516e","148":"acd009ae","180":"91df3865","225":"f9ebe8d9","331":"1fb126d0","407":"306b29ee","409":"f93b55dd","416":"e140935f","455":"650b5afe","472":"ab12d276","591":"e6736e6a","604":"dfaba21b","782":"8ebdc870","847":"eaa7aa2c"}[chunkId] + ".chunk.js";
};